import { Controller } from '@hotwired/stimulus';
import { openModal } from './modal_controller';
import { canOpenViaShortcut } from '../modal_shortcuts';

export default class extends Controller {
  static values = { shortcut: String };

  connect() {
    if (!this.hasShortcutValue) return;

    this.boundOpenByShortcut = this.openByShortcut.bind(this);
    document.addEventListener('keydown', this.boundOpenByShortcut);
  }

  disconnect() {
    if (this.boundOpenByShortcut) document.removeEventListener('keydown', this.boundOpenByShortcut);
  }

  open(event) {
    event.preventDefault();
    this.dispatchOpen(event.currentTarget);
  }

  openOnSubmit() {
    this.dispatchOpen(this.element);
  }

  openByShortcut(event) {
    if (event.key !== this.shortcutValue) return;
    if (!canOpenViaShortcut(event)) return;

    event.preventDefault();
    this.dispatchOpen(this.element);
  }

  dispatchOpen(element) {
    const modalId = element.dataset.modalId;
    if (!modalId) return;

    openModal(modalId);
  }
}
